// Context provider-agnostic per il modulo mail (Gmail / Outlook).
// I componenti condivisi in src/components/mail leggono da qui lo store del
// provider attivo (useStore), lo store del drawer (useDrawerStore) e il nome
// da mostrare in UI (displayName). Il descriptor concreto vive in providers.ts.
import { createContext, useContext } from 'react';
import type { useGmailStore } from '../../lib/stores/gmailStore';
import type { useGmailDrawerStore } from '../../lib/stores/gmailDrawerStore';

export interface MailProviderValue {
  provider: 'google' | 'microsoft';
  displayName: string;
  // Hook zustand dello store mail del provider (creato da createMailStore).
  useStore: typeof useGmailStore;
  // Hook zustand dello stato apertura/mode del drawer del provider.
  useDrawerStore: typeof useGmailDrawerStore;
}

const MailProviderContext = createContext<MailProviderValue | null>(null);

export function useMailProvider(): MailProviderValue {
  const ctx = useContext(MailProviderContext);
  if (!ctx) {
    throw new Error('useMailProvider deve essere usato dentro un <MailProviderContext.Provider>');
  }
  return ctx;
}

export { MailProviderContext };
